/**
 *
 *
 **/
function formatSimpleDate(date, splitter='-') {
	let d = new Date(date),
		month = d.getMonth() + 1,
		day = d.getDate(),
		year = d.getFullYear();

	if (month < 10) {
		month = "0" + month;
	}
	if (day < 10) {
		day = "0" + day;
	}

	return year + splitter + month + splitter + day;
}

/* ========================================================================== *\
	EXPORTS
\* ========================================================================== */
export {
	formatSimpleDate
};
